import styled from 'styled-components';
import backgroundImage from 'static/images/login/background.png';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent
    linear-gradient(
      180deg,
      ${({ theme }) => theme.pink} 0%,
      ${({ theme }) => theme.purple} 100%
    );
`;

export const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: -20%;
  background-image: url(${backgroundImage});
  background-size: cover;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  right: 10%;
  width: 30vw;
  min-width: 500px;
  max-width: 700px;
  height: 100vh;
  background: ${({ theme }) => theme.neutral_200};
  color: ${({ theme }) => theme.neutral_500};
  padding: 5vh 5vw;
  box-shadow: -28px 12px 40px #33333361;

  @media only screen and (max-width: 650px) {
    left: 0;
    width: 100%;
    min-width: 375px;
  }

  svg {
    width: 100%;
    max-width: 280px;
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .google-terms {
    font-weight: 300;
    font-size: 10px;
    line-height: 14px;
    color: ${({ theme }) => theme.neutral_500};

    a {
      color: ${({ theme }) => theme.primary_300};
    }
  }

  .support {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.neutral_500};

    a {
      color: ${({ theme }) => theme.primary_300};
    }
  }
`;
